import React, {useContext} from 'react';

export const LogoContext = React.createContext<string>('');

export function useLogo() {
  return useContext(LogoContext);
}
